import moment from 'moment';
import { openPrintWindow, escapeHtml } from '../MedicineOrders/printDispenseAuthorization';
import { buildMinistryPrintHtml } from '../../Shared/printLayout';

function fmtDate(v) {
    if (!v) return '—';
    try { return moment(v).format('YYYY/MM/DD HH:mm'); } catch { return '—'; }
}

export function buildInventoryCountHtml(detail) {
    const rows = (detail.lines || []).filter((line) => !line.isCancelled).map((line, index) => {
        const diff = Number(line.differenceQty ?? ((line.actualQty || 0) - (line.systemQty || 0)));
        const diffColor = diff > 0 ? '#16a34a' : (diff < 0 ? '#dc2626' : '#475569');
        return `
        <tr class="${index % 2 === 0 ? 'bg-gray-striped-1' : 'bg-gray-striped-2'}">
            <td>${index + 1}</td>
            <td>${escapeHtml(line.productName || '—')}</td>
            <td>${escapeHtml(line.batchNumber || '—')}</td>
            <td>${line.expiryDate ? escapeHtml(moment(line.expiryDate).format('YYYY/MM/DD')) : '—'}</td>
            <td>${Number(line.systemQty || 0).toLocaleString()}</td>
            <td>${Number(line.actualQty || 0).toLocaleString()}</td>
            <td style="color:${diffColor};font-weight:700">${diff > 0 ? '+' : ''}${diff.toLocaleString()}</td>
        </tr>`;
    }).join('');

    const infoHtml = `
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>رقم السند</th><td>${escapeHtml(detail.code || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>النوع</th><td>سند جرد</td></tr>
              <tr class="bg-gray-striped-1"><th>الحالة</th><td>${escapeHtml(detail.statusLabel || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>عدد الأصناف</th><td>${(detail.lines || []).filter((line) => !line.isCancelled).length}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>المرفق</th><td>${escapeHtml(detail.branchName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>القسم</th><td>${escapeHtml(detail.departmentName || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>المخزن</th><td>${escapeHtml(detail.stockingName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>أُنشئ بواسطة</th><td>${escapeHtml(detail.createdByName || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>تاريخ الإنشاء</th><td>${escapeHtml(fmtDate(detail.createdOn))}</td></tr>
              <tr class="bg-gray-striped-2"><th>تاريخ الترحيل</th><td>${escapeHtml(fmtDate(detail.finalizedOn))}</td></tr>
            </tbody>
          </table>
        </div>`;

    const bodyHtml = `
      <div class="mb-3"><strong>ملاحظة:</strong> ${escapeHtml(detail.note || '—')}</div>
      <table class="table table-sm table-bordered text-center border border-dark align-middle mt-1">
        <thead>
          <tr class="bg-gray">
            <th>#</th><th>الصنف</th><th>الدفعة</th><th>الصلاحية</th><th>رصيد النظام</th><th>الفعلي</th><th>الفرق</th>
          </tr>
        </thead>
        <tbody>${rows || '<tr><td colspan="7" class="text-center">لا توجد أصناف.</td></tr>'}</tbody>
      </table>`;

    const signaturesHtml = `
        <div class="col-4"><p><strong>لجنة الجرد</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>مسؤول المخزن</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>اعتماد الجهة المختصة</strong><br/>الاسم: ............................<br/>التوقيع والختم: ............................</p></div>`;

    return buildMinistryPrintHtml({
        title: 'سند جرد',
        docRef: detail.code || detail.id || '',
        infoHtml,
        bodyHtml,
        signaturesHtml,
        footerSummary: 'وثيقة جرد وتسوية تُستخدم لمطابقة الرصيد الفعلي مع رصيد النظام واعتماد الفروقات حسب الإجراءات المعتمدة. لا يُعتد بالنسخ الناقصة التوقيع أو الختم.',
        footerMeta: `مرجع الجرد: <strong>${escapeHtml(detail.code || String(detail.id || ''))}</strong>`
    });
}

export function printInventoryCount(detail) {
    return openPrintWindow(buildInventoryCountHtml(detail));
}
